import { ReactElement } from 'react';

import { Table, TableBody, TableContainer } from '@mui/material';

import { TableFlexOverflowContainer } from '@/components';

import { UsersList } from './UsersList';
import { UsersPagination } from './UsersPagination';
import { UsersTableHead } from './UsersTableHead';

export const UsersTable = (): ReactElement => {
  return (
    <TableFlexOverflowContainer>
      <TableContainer>
        <Table stickyHeader>
          <colgroup>
            <col style={{ width: '10%' }} />
            <col style={{ width: '20%' }} />
            <col style={{ width: '10%' }} />
            <col style={{ width: '10%' }} />
            <col style={{ width: '20%' }} />
            <col style={{ width: '20%' }} />
            <col style={{ width: '10%' }} />
            <col style={{ width: '10%' }} />
          </colgroup>
          <UsersTableHead />
          <TableBody>
            <UsersList />
          </TableBody>
        </Table>
      </TableContainer>

      <UsersPagination />
    </TableFlexOverflowContainer>
  );
};
